import httpClient from '../httpClient';
import { API_ENDPOINTS, ApiResponse } from '../api';

export interface RangeTemplateItem {
  msRangeTemplateItemID?: string;
  msRangeTemplateID?: string | null;
  label: string;
  value: string;
  sequence: number;
  userIn?: string | null;
  userUp?: string | null;
  dateIn?: string;
  dateUp?: string | null;
  isDeleted?: boolean;
}

export interface RangeTemplate {
  msRangeTemplateID?: string; // Make optional for creation
  templateName: string;
  description: string;
  isDefault: boolean;
  items: RangeTemplateItem[];
  userIn?: string | null; // Make optional
  userUp?: string | null; // Make optional
  dateIn?: string; // Make optional
  dateUp?: string | null; // Make optional
  isDeleted?: boolean; // Make optional
}

export const rangeTemplateService = {
  getList: async (params?: { pageNumber?: number; pageSize?: number; search?: string }) => {
    const response = await httpClient.get<ApiResponse<RangeTemplate>>(
      API_ENDPOINTS.RANGE_TEMPLATE.LIST,
      {
        params: {
          pageNumber: params?.pageNumber || 1,
          pageSize: params?.pageSize || 10,
          search: params?.search || ''
        }
      }
    );
    return response.data;
  },

  getDetail: async (id: string) => {
    const response = await httpClient.get<{ message: string; data: RangeTemplate }>(
      API_ENDPOINTS.RANGE_TEMPLATE.DETAIL(id)
    );
    return response.data;
  },

  create: async (template: RangeTemplate) => {
    const response = await httpClient.post(API_ENDPOINTS.RANGE_TEMPLATE.CREATE, template);
    return response.data;
  },

  update: async (template: RangeTemplate) => {
    const response = await httpClient.put(API_ENDPOINTS.RANGE_TEMPLATE.UPDATE, template);
    return response.data;
  },

  delete: async (id: string) => {
    const response = await httpClient.delete(API_ENDPOINTS.RANGE_TEMPLATE.DELETE, {
      data: { MsRangeTemplateID: id }
    });
    return response.data;
  }
};
